import React from "react";

const PlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <path
        d="M3 9.50004V6.83004C3 3.51504 5.3475 2.15754 8.22 3.81504L10.5375 5.15004L12.855 6.48504C15.7275 8.14254 15.7275 10.8575 12.855 12.515L10.5375 13.85L8.22 15.185C5.3475 16.8425 3 15.485 3 12.17V9.50004Z"
        stroke="#3DC583"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PlayIcon;
